import { connect } from 'react-redux';
import {
  setCallAudio,
  addPerson,
  removePerson,
  setPersonField,
  setField,
  addTag,
  deleteTag,
  changeLanguage,
} from '@actions/transcript';
import {
  selectCallAudio,
  selectPeople,
  selectTimezone,
  selectOrganizationId,
  selectCurrentOrganization,
  selectDefaultAttendees,
} from '@selectors/transcript';
import { getAvailableLanguagesRequestAction } from '@actions/trscService';
import { selectNumbersByCountries } from '@selectors/countries';
import { tokenSelector } from '@selectors/authentication';
import { selectIntroMessagesList } from '@selectors/introMessages';
import { getIntroMessagesRequestAction } from '@actions/introMessages';
import { selectOrganizationsList } from '@selectors/organizations';
import { selectAvailableLanguages } from '@selectors/trscService';
import {
  loadAllOrganizationsRequestAction,
  updateOrganizationFieldAction,
} from '@actions/organizations';
import CreateTranscriptForm from './CreateTranscriptForm';

const mapStateToProps = (state) => ({
  callAudio: selectCallAudio(state),
  token: tokenSelector(state),
  title: state.transcript.title,
  pin: state.transcript.pin,
  clientReference: state.transcript.clientReference,
  errors: state.transcript.errors,
  date: state.transcript.date,
  timezone: selectTimezone(state),
  people: selectPeople(state),
  defaultAttendees: selectDefaultAttendees(state),
  numbersByCountries: selectNumbersByCountries(state),
  conferenceCallUuid: state.transcript.conferenceCallUuid,
  tags: state.transcript.tags,
  isTranscriptNeeded: state.transcript.isTranscriptNeeded,
  isAITranscriptNeeded: state.transcript.isAITranscriptNeeded,
  isTwoFactorAuthRequired: state.transcript.isTwoFactorAuthRequired,
  userId: state.transcript.userId,
  organizationId: selectOrganizationId(state),
  organization: selectCurrentOrganization(state),
  organizationsList: selectOrganizationsList(state),
  language: state.conference.language,
  languagesList: selectAvailableLanguages(state),
  isAITranscriptionEnabled: state.trsc.isAITranscriptionEnabled,
  isHumanTranscriptionEnabled: state.trsc.isHumanTranscriptionEnabled,
});

const mapDispatchToProps = {
  setCallAudio,
  addPerson,
  removePerson,
  setPersonField,
  setField,
  addTag,
  deleteTag,
  loadOrganizationsList: loadAllOrganizationsRequestAction,
  updateOrganizationField: updateOrganizationFieldAction,
  getIntroMessagesList: getIntroMessagesRequestAction,
  getAvailableLanguagesList: getAvailableLanguagesRequestAction,
  changeLanguage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateTranscriptForm);



// WEBPACK FOOTER //
// ./components/templates/CreateTranscriptForm/index.js